<template>
  <div class="products-jsl-page-content flex flex-col items-center w-full">
    <section class="relative w-full flex flex-col items-center max-ml:hidden">
      <Pic class="w-full relative z-0 min-h-20rem  max-ml:object-cover max-ml:object-center"
        src="/images/pages/products/jsl/Frame 427321212.png" alt="" />
      <PageContentCenter class="text-[#fff] absolute top-[136px]">
        <h2 class="text-42.08px text-[#1F2329] mb-[8px]">
          {{ title }}
        </h2>
        <p class="color-#616671">{{ description }}</p>
      </PageContentCenter>
    </section>

    <section class="ml:hidden w-full">
      <Pic class="w-full" src="/images/mobile/products/jsl.png"></Pic>
    </section>

    <section class="relative w-full">
      <h2 class="text-2rem text-[#272E3B] pt-[5rem] text-center mb-5.25rem font-bold">
        {{ content.businessIntroduction.title }}
      </h2>
      <PageContentCenter class="text-[#272E3B] relative">
        <div class="relative flex max-ml:flex-col">
          <div class="relative align-self-center max-ml:w-full">
            <ul class="features-group-ul">
              <li v-for="desc in content.businessIntroduction.descList"
                class="text-[#616671] text-[1rem] mb-[2rem] features-group-li w-[38rem] max-ml:w-full">{{ desc
                }}
              </li>
            </ul>

          </div>
          <Pic class="w-[41.75rem] translate-x-[116px] mb-3.81rem max-ml:w-full max-ml:translate-x-0"
            :src="content.businessIntroduction.mainImage"></Pic>
        </div>
      </PageContentCenter>
    </section>

    <section class="w-full ">

      <h2 class="text-2rem text-[#272E3B] pt-[5rem] text-center bg-[#F6F8FD] font-bold">
        {{ content.featuresIntroduction.title }}
      </h2>

      <section :class="['py-3.56rem', group.direction === 'image-to-copywriting' ? 'bg-[#EFF7FF]' : '']"
        v-for="group in content.featuresIntroduction.groups" :style="{ backgroundColor: group.bgColor }">
        <PageContentCenter
          :class="['flex', 'justify-center', 'gap-160px', 'relative', group.direction === 'image-to-copywriting' ? 'ml:flex-row-reverse' : '', 'max-ml:flex-col!', 'max-ml:gap-20px']">
          <div class="w-370px relative top-1/2 align-self-center max-ml:w-100%">
            <div :class="['mb-1.75rem']">
              <Pic :src="group.icon" class="w-[7rem] h-6.88rem mb-1.75rem max-lg:hidden"></Pic>
              <h4 class="text-1.88rem">{{ group.title }}</h4>
            </div>
            <ul class="features-group-ul w-360px max-ml:w-full">
              <li v-for="desc in group.descList" class="text-[#616671] text-[1rem] mb-[2rem] features-group-li">{{ desc
              }}
              </li>
            </ul>
          </div>
          <Pic class="w-42.25rem max-ml:w-100%" :src="group.mainImage"></Pic>
        </PageContentCenter>
      </section>
    </section>

    <section class="w-full pl-0 pr-0 pb-6.88rem products-jsl-cpys max-ml:hidden">
      <h2 class="text-2rem text-[#272E3B] pt-[80px] text-center mb-4.8rem font-bold">
        {{ content.advantage.title }}
      </h2>
      <PageContentCenter class="relative jsl-customer-product-functions flex flex-row h-[33.75rem] ">
        <v-tabs v-model="tab" align-tabs="center" direction="vertical" color="#1967F9">
          <v-tab :value="item.title" v-for="item in content.advantage.list" class="h-33% w-15.5rem">
            <div class="flex items-center">
              <Pic :src="item.icon" class="w-3.13rem h-3.13rem"></Pic>
              <h5 class="color-#272E3B text-1.5rem pl-1rem name font-400">{{ item.title }}</h5>
            </div>
          </v-tab>
        </v-tabs>

        <v-tabs-window v-model="tab" class="flex-1">
          <v-tabs-window-item class="flex text-left justify-between" v-for="item in content.advantage.list"
            :value="item.title">
            <div class="pl-[4.7rem] flex flex-row align-start flex-1">
              <div>
                <div class="color-#272E3B weight-600 text-[1.88rem] pt-2.63rem">{{ item.brief }}</div>
                <ul class="mt-5.38rem">
                  <li v-for="desc in item.desc" class="text-[#272E3B] text-[1.13rem] mb-[1.88rem] listStyle">{{ desc
                  }}</li>
                </ul>
                <div class="mt-5rem w-11.75rem">
                  <v-btn class="rounded-[8px]! " size="x-large" variant="flat" block color="#1967F9">
                    <span class="text-[1rem]">立即体验</span>
                  </v-btn>
                </div>
              </div>
              <div class="flex-1 flex justify-end">
                <Pic :src="item.briefBack" class="w-42rem h-33.75rem"></Pic>
              </div>
            </div>
          </v-tabs-window-item>
        </v-tabs-window>

      </PageContentCenter>
      <PageContentCenter class="hidden max-ml:hidden">
        <div class="flex text-left justify-between flex-col pb-2rem" v-for="item in content.advantage.list"
          :value="item.title">
          <div class="pl-20px flex flex-col align-start flex-1">
            <div class="flex-1 flex justify-end">
              <Pic :src="item.briefBack" class="w-100% h-auto"></Pic>
            </div>
            <div>
              <div class="color-#272E3B weight-600 text-[1.88rem] pt-2.63rem">{{ item.brief }}</div>
              <ul class="mt-5.38rem">
                <li v-for="desc in item.desc" class="text-[#272E3B] text-[1.13rem] mb-[1.88rem] listStyle">{{ desc
                  }}</li>
              </ul>
              <div class="mt-40px w-11.75rem">
                <v-btn class="rounded-[8px]! " size="x-large" variant="flat" block color="#1967F9">
                  <span class="text-[1rem]">立即体验</span>
                </v-btn>
              </div>
            </div>

          </div>
        </div>

      </PageContentCenter>
    </section>
    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { useSeoMeta } from 'nuxt/app'
const title = '即时榔'
const description = '重构快消零售 激活场景价值'
useSeoMeta({
  title,
  description,
})
const tab = ref(null)
const content = shallowReactive({
  businessIntroduction: {
    title: '产品业务介绍',
    // 副标题
    subTitle: '产品业务介绍',
    desc: '',
    mainImage: '/images/pages/products/jsl/image (3) 3@2x.png',
    descList: [
      '搭载物联网+AI 技术的新一代智能零售终端',
      '以“轻资产 + 强联动”为核心模式，深度适配高人流场景需求',
      '提供 24 小时不间断的无人零售解决方案 — 从消费者即时购买到运营方智能管理',
      '从补货端成本优化到多方合作分润，全链路打通快消零售痛点',
    ]
  },
  featuresIntroduction: {
    title: '产品功能介绍',
    desc: '',
    groups: [
      {
        title: '扫码极速下单',
        desc: '',
        descList: [
          '消费者通过小程序扫码即可完成下单，无需下载 APP',
          '操作流程简化至3步内，契合无人零售“即时性”核心需求',
          '让购买更高效'
        ],
        icon: '/images/pages/products/jsl/产品功能介绍-扫码极速下单@2x.png',
        mainImage: '/images/pages/products/jsl/Frame 1171275013@2x.png',
        direction: 'copywriting-to-image',
        bgColor: '#F6F8FD'
      },
      {
        title: '订单实时跟踪',
        desc: '',
        descList: ['消费者在小程序内可实时查看订单状态（待支付 / 待取货 / 已完成）', '搭载红外传感器精准检测出货口掉货状态', '避免漏取、错取，提升消费体验',],
        icon: '/images/pages/products/jsl/产品功能介绍-自动化对账分账@2x.png',
        mainImage: '/images/pages/products/jsl/Group 1171275056@2x.png',
        direction: 'image-to-copywriting',
        bgColor: '#fff'
      },
      {
        title: '设备全周期管理',
        desc: '',
        descList: ['商家/运营方通过管理系统可完成设备“新增 - 修改 - 删除 - 投放”全流程操作', '支持查看设备实时状态（库存、销量、故障报警）', '实现线下设备的线上化、精细化管理',],
        icon: '/images/pages/products/jsl/产品功能介绍-设备全周期管理@2x.png',
        mainImage: '/images/pages/products/jsl/Group 1171275057@2x.png',
        direction: 'copywriting-to-image',
        bgColor: '#F6F8FD'
      },
      {
        title: '扫码智能补货',
        desc: '',
        descList: ['补货员通过专属小程序扫码识别设备，系统自动展示待补商品、补货数量', '无需人工盘点，补货效率提升 50% 以上',],
        icon: '/images/pages/products/jsl/产品功能介绍-扫码智能补货@2x.png',
        mainImage: '/images/pages/products/jsl/Group 1171275058@2x.png',
        direction: 'image-to-copywriting',
        bgColor: '#fff'
      },
      {
        title: '库存精准管控',
        desc: '',
        descList: ['系统实时同步设备库存数据，库存低于阈值时自动触发补货提醒', '支持“商品出库-入库-盘点”全记录，确保库存准确率＞99%', '为运营决策提供数据支撑',],
        icon: '/images/pages/products/jsl/产品功能介绍-库存精准管控@2x.png',
        mainImage: '/images/pages/products/jsl/Group 1171275020@2x.png',
        direction: 'copywriting-to-image',
        bgColor: '#F6F8FD'
      },
      {
        title: '自动化对账分账',
        desc: '',
        descList: ['搭载全链路自动化对账结算系统，覆盖“场地方-经销商-品牌方”多级分润场景', '实时同步资金流、票据流数据，避免人工对账误差', '实现多方资金清晰、高效分账',],
        icon: '/images/pages/products/jsl/产品功能介绍-自动化对账分账@2x.png',
        mainImage: '/images/pages/products/jsl/Group 1171275020@2x(1).png',
        direction: 'image-to-copywriting',
        bgColor: '#fff'
      }, {
        title: '商品智能调价',
        desc: '',
        descList: ['支持根据场景人流（如早晚高峰、节假日）', '商品库存余量动态调整售价，通过管理系统一键设置调价规则', '灵活适配市场需求，提升商品周转效率与收益'],
        icon: '/images/pages/products/jsl/产品功能介绍-商品智能调价@2x.png',
        mainImage: '/images/pages/products/jsl/Group 1171275035@2x.png',
        direction: 'copywriting-to-image',
        bgColor: '#F6F8FD'
      }, {
        title: '高效售后响应',
        desc: '',
        descList: ['消费者可通过小程序发起售后申请（如取货失败、商品问题）', '商家/运营方实时接收工单并快速处理', '售后响应时效缩短至1小时内，保障消费口碑'],
        icon: '/images/pages/products/jsl/产品功能介绍-高效售后响应@2x.png',
        mainImage: '/images/pages/products/jsl/Group 1171275037@2x.png',
        direction: 'image-to-copywriting',
        bgColor: '#fff'
      },
    ]
  },
  advantage: {
    title: '产品优势',
    list: [
      {
        title: '硬件可靠',
        brief: '硬件可靠 品质保障',
        desc: ['采用封闭式机身，防尘防潮锁鲜', '库存精准度＞99%，出货故障率＜0.3%', '杜绝卡货、损耗问题'],
        briefBack: '/images/pages/products/jsl/产品优势-底图1@2x.png',
        icon: '/images/pages/products/jsl/icon-硬件可靠@2x.png'
      },
      {
        title: '智能运营',
        desc: ['AI算法预测销量，动态调整补货量（降低30%补货成本）', '支持商品智能调价、多端管理', '运营效率提升50%'],
        brief: '智能运营  降本提效率',
        briefBack: '/images/pages/products/jsl/产品优势-底图2@2x (1).png',
        icon: '/images/pages/products/jsl/icon-智能运营@2x.png'
      },
      {
        title: '灵活分账',
        brief: '灵活分账  多方互赢',
        desc: ['自动化对账结算系统，覆盖场地方/ 经销商 / 品牌方多级分佣', '资金流、票据流、数据流“三流合一”', '安全可追溯'],
        briefBack: '/images/pages/products/jsl/产品优势-底图3@2x (1).png',
        icon: '/images/pages/products/jsl/icon-灵活分账@2x.png'
      },

    ]
  }
})
</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-jsl-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .jsl-customer-product-functions {
    border-radius: 0.75rem;
    background: linear-gradient(to bottom, #bcdbff 0%, #fff 30%, #fff 100%);

    :deep(.v-slide-group__content .v-btn) {
      height: 33.3%;
    }

    :deep(.v-tab__slider) {
      top: 5%;
      left: 0 !important;
      height: 90%;
    }

    :deep(.v-tab--selected) {
      background: linear-gradient(90deg, #cae2ff 0%, rgba(218, 235, 255, 0%) 100%);
    }

    :deep(.v-tab--selected .name) {
      color: #1967f9 !important;
    }

    :deep(.v-tab--selected .v-tab__slider) {
      width: 3px;
      background-image: linear-gradient(180deg, rgba(110, 190, 255, 100%), rgba(55, 95, 242, 100%));
    }

    .listStyle {
      position: relative;
      padding-left: 2rem;

      &::before {
        position: absolute;
        top: 50%;
        left: 0;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-top: -4px;
        background-color: #375ff2;
        content: "";
      }
    }
  }

  .jsl-product-advantage-item {
    width: 28.38rem;
    height: 21.38rem;
    border-radius: 1.25rem 1.25rem 0 0;
    background: linear-gradient(180deg, #d0e8ff 0%, #fff 100%);

    .jsl-product-advantage-item-brief {
      width: 100%;
      height: 5.56rem;
      border-radius: 0 0 1.25rem 1.25rem;
      background-size: cover;
      color: #fff;
      font-size: 1.5rem;
      font-weight: bold;
      line-height: 5.56rem;
      text-align: center;
    }
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 2rem;

      &::before {
        position: absolute;
        z-index: 0;
        top: 4px;
        left: 0;
        width: 1.06rem;
        height: 1.06rem;
        background-image: url("/images/pages/products/jsl/Frame 1171274835@2x.png");
        background-repeat: no-repeat;
        background-size: contain;
        content: "";
      }

      &.B {
        &::before {
          background-image: url("/images/pages/products/jsl/Frame 1171274835@2x(1).png");
        }
      }
    }
  }
}

.jsl-business-introduction-title {
  position: relative;
  padding-left: 20px;

  &::before {
    position: absolute;
    z-index: 0;
    top: 10px;
    left: 0;
    width: 0.25rem;
    height: 1.5rem;
    border-radius: 0;
    background: #1967f9;
    content: "";
  }

  &::after {
    position: absolute;
    z-index: 0;
    top: -48px;
    left: 69px;
    width: 18.38rem;
    height: 4.44rem;
    color: #f4f8ff;
    content: "BUSINESS";
    font-size: 3.38rem;
    font-style: normal;
    font-weight: 800;
    text-align: left;
    text-transform: none;
  }
}

.jsl-product-advantage {
  background-image: url("/images/pages/products/jsl/Group 1171274840@2x.png");
}

.products-jsl-cpys {
  background-image: url("/images/pages/products/jsl/Frame 1171275061@2x.png");
  background-size: cover;
}
</style>
